export const insB = [
	"none",
	"Allied",
	"Amana Takaful",
	"Solarelle",
	"Police",
	"MNDF",
];

export default insB;
